import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null, // 用户信息
    selectionAddress: {
      categoryname: "北京市",
      city_id: 35,
      parentid: 1,
      spell: "beijingshi"
    }, // 当前的选中城市，默认北京
    topNav:0,         // 顶部导航显示高亮
  },
  mutations: {

  },
  actions: {

  }
})
